import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { APP_VALIDATION_REGEX } from 'src/app/app.contant';
import { ILineItemResultMap, ISupplierMarketResult } from '../../../models';

@Component({
  selector: 'app-update-vendor-email',
  templateUrl: './update-vendor-email.component.html',
  styleUrls: ['./update-vendor-email.component.scss'],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class UpdateVendorEmailComponent implements OnInit {

  public title !: string;
  public marketResults !: ILineItemResultMap;
  public onClose = new BehaviorSubject<any>({});

  // form group
  public marketResultForm !: FormGroup;

  constructor(
    public bsModalRef: BsModalRef,
    private _fb : FormBuilder) { }

  ngOnInit(): void {
    if(this.marketResults) {
      this.prepareMarketResultForm();
    }
  }

  getFormArrayName(prop: string): any {
    const formArr =  this.marketResultForm.controls[prop] as FormGroup;
    return formArr.controls
  }

  /* Creating a dynamic nested form for validation & redndering on UI on the basis of the values */
  private prepareMarketResultForm() : void {
    const customForm : FormGroup = this._fb.group({});
    Object.keys(this.marketResults).forEach((materialMasterId : any) => {
      const formArray : FormArray =  new FormArray([]);
      this.marketResults[materialMasterId].supplierMarketResult.forEach((marketResultElement : ISupplierMarketResult) => {
        const nestedForm : FormGroup =  this._fb.group({});
        Object.keys(marketResultElement).forEach((key : string) => {
          const defaultValue = marketResultElement[key as keyof ISupplierMarketResult];
          console.log("defaultValue",key , defaultValue)
          if(defaultValue){
            if(key === "EMAIL_ADDRESS") { /* If fiels is email address then adding validator */
              nestedForm.addControl(key, new FormControl(defaultValue, [Validators.required, Validators.pattern(APP_VALIDATION_REGEX['EMAIL_PATTERN'])]));
            } else {
              nestedForm.addControl(key, new FormControl(defaultValue, []));
            }
          }
        })
        formArray.push(nestedForm);
      });
      customForm.addControl(materialMasterId, formArray)
    });
    this.marketResultForm = customForm;
  }

  public updateEmailInfo() : void {
    console.log(this.marketResultForm);
    const formValue = this.marketResultForm.value;
    let data : ILineItemResultMap = {};
    Object.keys(this.marketResults).forEach((materialId : any) => {
      data[materialId] = {
        COMP_CODE : this.marketResults[materialId].COMP_CODE,
        MaterialNumber : this.marketResults[materialId].MaterialNumber,
        MATERIAL_MASTER_ID : this.marketResults[materialId].MATERIAL_MASTER_ID,
        PURCH_ORG : this.marketResults[materialId].PURCH_ORG,
        LINE_ITEM_NUMBER : this.marketResults[materialId].LINE_ITEM_NUMBER,
        supplierMarketResult : formValue[materialId],
      }
    });
    this.closeModal(data)
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: ILineItemResultMap) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

}
